module.exports = __webpack_public_path__ + "static/media/generic-cb.e876d192.jpeg";